import React, { useRef, useState, useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import ClassNames from "classnames"
import { find, get, filter, map, orderBy, reverse, isEmpty } from "lodash"
import { tableColumns } from "config/table_columns"
import { PUT_OR_CALL } from "config/const"
import { BaseTable, OptionTable } from "components/molecules/table"
import { BaseSelect } from "components/atoms/input/select"
import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import * as Formatter from "utils/Formatter"
import { changeSymbol, changeSpModalSymbol } from "redux/ducks/Chart"
import { checkIsSp, getPriceCompareText, priceCompareIcon } from "utils/util"
import store from "redux/store"
import { LoadStateType, pageLoadRegist } from "redux/ducks/PageLoad"
import uuid from "uuid"

export const label = [
  {
    id: "NewestOnly",
    name: "主要先物",
    Symbol: "101",
    requestDetail: {
      Symbol: "101",
      Exchange: 1,
      SecurityType: 0,
    },
    request: [
      {
        name: "日経225先物",
        Symbol: "163120018",
        Exchange: 2,
        SecurityType: 101,
      },
      {
        name: "日経225ミニ先物",
        Symbol: "165030019",
        Exchange: 23,
        SecurityType: 901,
      },
      {
        name: "JPX日経400先物",
        Symbol: "165030022",
        Exchange: 23,
        SecurityType: 121,
      },
      {
        name: "TOPIX先物",
        Symbol: "163060005",
        Exchange: 23,
        SecurityType: 107,
      },
      {
        name: "TOPIXミニ先物",
        Symbol: "165030018",
        Exchange: 2,
        SecurityType: 907,
      },
      {
        name: "CORE30先物",
        Symbol: "165030018",
        Exchange: 2,
        SecurityType: 171,
      },
      {
        name: "REIT先物",
        Symbol: "165030018",
        Exchange: 2,
        SecurityType: 155,
      },
    ],
  },
  {
    id: "Main",
    name: "日経225先物",
    Symbol: "101",
    requestDetail: {
      Symbol: "101",
      Exchange: 1,
      SecurityType: 0,
    },
    request: [
      {
        name: "日経225先物",
        Symbol: "163120018",
        Exchange: 2,
        SecurityType: 101,
      },
      {
        name: "日経225ミニ先物",
        Symbol: "165030019",
        Exchange: 23,
        SecurityType: 901,
      },
    ],
  },
  {
    id: "Tse",
    name: "JPX日経400先物",
    Symbol: "105",
    requestDetail: {
      Symbol: "105",
      Exchange: 1,
      SecurityType: 0,
    },
    request: [
      {
        name: "JPX日経400先物",
        Symbol: "165030022",
        Exchange: 23,
        SecurityType: 121,
      },
    ],
  },
  {
    id: "Emerging",
    name: "TOPIX先物",
    Symbol: "151",
    requestDetail: {
      Symbol: "151",
      Exchange: 1,
      SecurityType: 0,
    },
    request: [
      {
        name: "TOPIX先物",
        Symbol: "163060005",
        Exchange: 23,
        SecurityType: 107,
      },
      {
        name: "TOPIXミニ先物",
        Symbol: "165030018",
        Exchange: 2,
        SecurityType: 907,
      },
    ],
  },
  {
    id: "All",
    name: "CORE30先物",
    Symbol: "171",
    requestDetail: {
      Symbol: "0028",
      Exchange: 1,
      SecurityType: 0,
    },
    request: [
      {
        name: "CORE30先物",
        Symbol: "165030018",
        Exchange: 2,
        SecurityType: 171,
      },
    ],
  },
  {
    id: "Change",
    name: "REIT先物",
    Symbol: "155",
    requestDetail: {
      Symbol: "155",
      Exchange: 1,
      SecurityType: 0,
    },
    request: [
      { name: "REIT先物", Symbol: "165030018", Exchange: 2, SecurityType: 155 },
    ],
  },
]

export const HeadInfo: React.FC<{
  data: APIResponse.Res
  onClick?: Function
}> = props => {
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  const [priceCompareText, setPriceCompareText] = useState("")
  const priceCompare = get(props.data, "PriceCompare")
  const iconClass: string = priceCompareIcon(priceCompare)

  useEffect(() => {
    get(props.data, "PriceCompare")
      ? getPriceCompareText(
          get(props.data, "PriceCompare"),
          priceCompareText,
          setPriceCompareText
        )
      : setPriceCompareText("")
  }, [props.data])
  return (
    <div
      className="price-detail-col"
      onClick={() => props.onClick && props.onClick()}
    >
      <div className="price-detail-row">
        <div className="price-detail-title">
          <i className="icon-solid icon-jp icon-m" />
          {get(props.data, "SymbolName", "")}
          {/* spの場合、銘柄名の横にする */}
          {isPhone && (
            <div className="time-col">
              {Formatter.date(get(props.data, "PriceTime"), "MM/DD HH:mm")}
            </div>
          )}
        </div>
        <div className="price-detail-value-col right-justify">
          <div className="price-detail-currency-col">
            {/*TODO:暫定：文言削除*/}
            {/*<div className="price-detail-currency-title">現在値</div>*/}
            <div className="price-detail-currency-value">
              {Formatter.number(
                get(props.data, "Price", null),
                get(props.data, "NumberOfDecimals", 0)
              )}
            </div>
            <i
              className={ClassNames("material-icons", iconClass, {
                empty: isEmpty(priceCompareText),
              })}
            >
              {priceCompareText}
            </i>
          </div>
          <div className="price-detail-currency-col">
            <div className="price-detail-change-price-col">
              <div
                className={ClassNames(
                  "price-detail-change-price",
                  Formatter.upDown(get(props.data, "ChangedPrice"))
                )}
              >
                {Formatter.number(
                  get(props.data, "ChangedPrice", null),
                  get(props.data, "NumberOfDecimals", 0),
                  "floor",
                  true
                )}
              </div>
              <div className="price-detail-change-ratio">
                (
                <span
                  className={ClassNames(
                    Formatter.upDown(get(props.data, "ChangedRatio"))
                  )}
                >
                  {Formatter.number(
                    get(props.data, "ChangedRatio", null),
                    2,
                    "floor",
                    true
                  )}
                </span>
                <span className="unit">%</span>)
              </div>
            </div>
          </div>
          {!isPhone && (
            <div className="time-col">
              {Formatter.date(get(props.data, "PriceTime"), "MM/DD HH:mm")}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

type FutureProps = {
  data?: APIResponse.Res
  canvasId?: string
  changeDisplay: Function
  callSymbolDetail?: Function
  symbolDetail?: APIResponse.Res
  underlyingAssetData?: APIResponse.Res
  refresh?: boolean
}

export const Future: React.FC<FutureProps> = props => {
  const dispatch = useDispatch()
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  const [displayId, changeDisplay] = useState<string>(label[0].id)
  const displayData: any = find(label, { id: displayId })
  const resultList = get(props.data, "ResultList")
  const _changeDisplay = (value: string) => {
    changeDisplay(value)
    props.changeDisplay(value)
  }
  const [currentPosition, changePosition] = useState<number>(0)
  const [currentTable, changeTable] = useState<number>(0)

  useEffect(() => {
    const resultList = get(props.data, "ResultList")
    const displayData: any = find(label, { id: displayId })
    let data: any[] = filter(resultList, {
      SecurityType: displayData.request[0].SecurityType,
    })
    if (data[0]) {
      props.callSymbolDetail(data[0])
      dispatch(changeSymbol(props.canvasId, data[0]))
      changePosition(0)
      changeTable(0)
    }
  }, [displayId, props.data])

  return (
    <>
      <div className="row-filter">
        <BaseSelect
          option={label}
          value={displayId}
          onChange={_changeDisplay}
        />
        <HeadInfo data={props.underlyingAssetData} />
      </div>
      <div className="split-col result-list-col result-tab-list-col">
        {map(displayData.request, (row, i: number) => {
          let data: any[] = filter(resultList, {
            SecurityType: row.SecurityType,
          })
          return (
            <div key={i} className="block-title-table">
              <div className="control-row filter-control-row">
                <div className="title-border">{get(row, "name")}</div>
              </div>
              <BaseTable
                className="table-list-view table-striped"
                list={!isPhone ? tableColumns.future : tableColumns.sp_future}
                data={data}
                active={i === currentTable && currentPosition}
                onClick={(data: any, x: number) => {
                  !isPhone
                    ? dispatch(changeSymbol(props.canvasId, data))
                    : dispatch(changeSpModalSymbol(data, true))
                  props.callSymbolDetail(data)
                  changePosition(x)
                  changeTable(i)
                }}
              />
            </div>
          )
        })}
      </div>
    </>
  )
}

export const Option: React.FC<FutureProps> = props => {
  const dispatch = useDispatch()
  const loadResistId = useMemo(() => uuid(), [])

  const [selectedYearMonth, setSelectedYearMonth] = useState(null)
  const [id, setId] = useState(0)
  const [resultList, setResultList] = useState([])
  const [putData, setPutData] = useState([])
  const [callData, setCallData] = useState([])
  const [stkList, setStkList] = useState([])
  const [yearMonthList, setYearMonthList] = useState([])
  const [filterList, setFilterList] = useState([])
  const [currentActivePosition, changeActivePosition] = useState<number>(-1)
  const [currentActivePutOrCall, changeActivePutOrCall] = useState<number>(-1)

  const changeFilter = (id: number) => {
    setId(id)
    setSelectedYearMonth(filterList[id])
  }
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const callSymbolList = async () => {
    store.dispatch(pageLoadRegist(loadResistId, true))

    const data = await APIs.SymbolDetail.SymbolList({
      TargetSecurityTypes: "103",
      Exchange: "2",
      YearMonth: selectedYearMonth,
    })
    const resultList = get(data, "ResultList", [])
    // 下記のorderByが効かないので、reverseを使用している。
    // setResultList(orderBy(resultList, ["StrikePrice"], ["desc"]))
    setResultList(reverse(resultList))
    const putResultList = filter(resultList, {
      PutOrCall: PUT_OR_CALL.PUT.id,
    })
    const callResulList = filter(resultList, {
      PutOrCall: PUT_OR_CALL.CALL.id,
    })
    setPutData(putResultList)
    setCallData(callResulList)
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  const callYearMonthList = async () => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    const data = await APIs.SymbolDetail.OptionSymbolList({
      TargetSecurityTypes: "103",
      Exchange: "2",
      YearMonthCount: "4",
    })
    const yearMonth = get(data, "ResultList", [])
    setFilterList(yearMonth)
    setYearMonthList(
      map(yearMonth, (str: string, i: number) => {
        return { id: i, name: `${Formatter.date(str, "YYYY/MM")}限月` }
      })
    )
    setSelectedYearMonth(yearMonth[0])
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  useEffect(() => {
    callYearMonthList()
  }, [])

  useEffect(() => {
    if (isPageLoading) {
      callYearMonthList()
      callSymbolList()
    }
  }, [isPageLoading])

  useEffect(() => {
    if (!selectedYearMonth) return
    callSymbolList()
  }, [selectedYearMonth])

  useEffect(() => {
    if (!props.refresh) return
    callSymbolList()
  }, [props.refresh])

  useEffect(() => {
    if (isEmpty(resultList) || isPhone) return
    //findで取得しているので、先にあるコールのデータを表示するようになっている。
    const symbol = find(resultList, { ATMFlag: true })
    dispatch(changeSymbol(props.canvasId, symbol))
    props.callSymbolDetail(symbol)
  }, [resultList])

  const callSymbolDetail = (symbol: any) => {
    if (symbol) {
      dispatch(changeSymbol(props.canvasId, {}))
      props.callSymbolDetail({})
      changeActivePosition(-1)
      changeActivePutOrCall(-1)
    }
  }

  useEffect(() => {
    setStkList(
      putData.map((data: APIResponse.Res) => get(data, "StrikePrice", null))
    )
  }, [putData])

  return (
    <div>
      <div className="row-filter">
        <BaseSelect value={id} option={yearMonthList} onChange={changeFilter} />
        <HeadInfo data={props.underlyingAssetData} />
      </div>
      <OptionTable
        callSymbolDetail={callSymbolDetail}
        call={callData}
        put={putData}
        stk={stkList}
        active={currentActivePosition}
        activePutOrCall={currentActivePutOrCall}
        onClick={async (symbol: any, index: number) => {
          if (!props.canvasId) return
          !isPhone
            ? dispatch(changeSymbol(props.canvasId, symbol))
            : dispatch(changeSpModalSymbol(symbol))
          props.callSymbolDetail(symbol)
          changeActivePosition(index)
          changeActivePutOrCall(symbol.PutOrCall)
        }}
      />
    </div>
  )
}
